import _ from 'underscore'
import configuration from '@/toolbar/configuration/Configuration.yml'
import RefusedNotDefined from '@/toolbar/inspector/Monitors/RefusedNotDefined'
import MetaViewportUndefined from '@/toolbar/inspector/Monitors/MetaViewportUndefined'
import PostAndGetDefined from '@/toolbar/inspector/Monitors/PostAndGetDefined'

export default class InspectorManager {
  constructor($locator) {
    this.$locator = $locator
  }

  /**
   * Method that recieve an array of warning codes (ranges and/or numbers)
   * and executes the classes indicated on warningInspector.yml
   *
   * @param {Array} codes
   * @returns {Promise}
   */
  inspect(codes) {
    let codesConfiguration = configuration.warningInspector
    let monitorClasses = []

    // Collect all the monitor classes
    for (const code of this.parseCodes(codes)) {
      if (codesConfiguration.hasOwnProperty(code)) {
        for (const monitorName of codesConfiguration[code]) {
          if (monitorClasses.indexOf(monitorName) === -1) {
            monitorClasses.push(monitorName)
          }
        }
      }
    }

    const $locator = this.$locator
    const monitors = {
      RefusedNotDefined,
      MetaViewportUndefined,
      PostAndGetDefined
    }
    // Instance monitors
    let monitorPromises = []
    for (const monitorClass of monitorClasses) {
      monitorPromises.push(
        new Promise((resolve, reject) => {
          // Creating first the monitor instance with the API
          let monitorInstance = new monitors[monitorClass]($locator)
          monitorInstance.monitor()

          resolve()
        })
      )
    }

    // Resolve monitors
    return Promise.all(monitorPromises)
  }

  /**
   * Method that recieves an array of numbers and/or ranges and returns
   * an array of the integers.
   *
   * @param {Array} codes
   * @returns {Array}
   * @memberof Toolbar_Inspector_InspectorManager
   */
  parseCodes(codes) {
    const codesResult = []

    if (_.isArray(codes)) {
      codes.forEach(code => {
        // Check if the value is a number
        if (_.isNumber(code) || code.match(/^\d{3}$/)) {
          if (codesResult.indexOf(code) === -1) codesResult.push(parseInt(code))
          // Check if the value is a range
        } else if (_.isString(code)) {
          if (
            code.match(/\d{3}-\d{3}/) &&
            parseInt(code.split('-')[0]) < parseInt(code.split('-')[1])
          ) {
            const splittedCode = code.split('-')
            let count = parseInt(splittedCode[0])
            while (count <= parseInt(splittedCode[1])) {
              if (codesResult.indexOf(count) === -1) codesResult.push(count)
              count++
            }
          }
        }
      })
    }

    return codesResult
  }
}
